import dateFns from 'date-fns/locale/hu';

export default {
  dateFns,

  format: {
    date: 'yyyy.M.d.',
    time: 'p',
    dateTime: '$t(format:date) $t(format:time)',
    longDate: 'MMM. d.',
    longDateTime: 'MMMM. d. p',
    fullDate: 'y. MMM d.',
    fullDateTime: 'y. MMMM d. p',
  },

  translation: {
    common: {
      aboutPlanka: 'Plankáról',
      account: 'Fiók',
      actions: 'Műveletek',
      addAttachment_title: 'Melléklet hozzáadása',
      addComment: 'Megjegyzés hozzáadása',
      addManager_title: 'Menedzser hozzáadása',
      addMember_title: 'Tag létrehozása',
      addUser_title: 'Felhasználó hozzáadása',
      administrator: 'Rendszergazda',
      all: 'Összes',
      allChangesWillBeAutomaticallySavedAfterConnectionRestored:
        'Az összes változás automatikusan mentésre kerül a kapcsolat helyreállása után.',
      areYouSureYouWantToDeleteThisAttachment: 'Biztosan törölni szeretné ezt a mellékletet?',
      areYouSureYouWantToDeleteThisBoard: 'Biztosan törölni szeretné ezt a táblát?',
      areYouSureYouWantToDeleteThisCard: 'Biztosan törölni szeretné ezt a kártyát?',
      areYouSureYouWantToDeleteThisComment: 'Biztosan törölni szeretné ezt a megjegyzést?',
      areYouSureYouWantToDeleteThisLabel: 'Biztosan törölni szeretné ezt a címkét?',
      areYouSureYouWantToDeleteThisList: 'Biztosan törölni szeretné ezt a listát?',
      areYouSureYouWantToDeleteThisProject: 'Biztosan törölni szeretné ezt a projektet?',
      areYouSureYouWantToDeleteThisTask: 'Biztosan törölni szeretné ezt a feladatot?',
      areYouSureYouWantToDeleteThisUser: 'Biztosan törölni szeretné ezt a felhasználót?',
      areYouSureYouWantToLeaveBoard: 'Biztosan el akarja hagyni a táblát?',
      areYouSureYouWantToLeaveProject: 'Biztosan el akarja hagyni a projektet?',
      areYouSureYouWantToRemoveThisManagerFromProject:
        'Biztosan eltávolítja ezt a menedzsert a projektből?',
      areYouSureYouWantToRemoveThisMemberFromBoard: 'Biztosan eltávolítja ezt a tagot a tábláról?',
      attachment: 'Melléklet',
      attachments: 'Mellékletek',
      authentication: 'Hitelesítés',
      background: 'Háttér',
      board: 'Tábla',
      boardNotFound_title: 'Tábla nem található',
      canComment: 'Hozzászólhat',
      canEditContentOfBoard: 'Szerkesztheti a tábla tartalmát.',
      canOnlyViewBoard: 'Csak megtekintheti a táblát.',
      cardActions_title: 'Kártya műveletek',
      cardNotFound_title: 'Kártya nem található',
      cardOrActionAreDeleted: 'A kártya vagy művelet törölve lett.',
      color: 'Szín',
      copy_inline: 'másolás',
      createBoard_title: 'Tábla létrehozása',
      createLabel_title: 'Címke létrehozása',
      createNewOneOrSelectExistingOne: 'Hozzon létre egy újat, vagy válasszon ki egy meglévőt.',
      createProject_title: 'Projekt létrehozása',
      createTextFile_title: 'Szövegfájl létrehozása',
      currentPassword: 'Jelenlegi jelszó',
      dangerZone_title: 'Veszélyzóna',
      date: 'Dátum',
      dueDate: 'Határidő',
      dueDate_title: 'Esedékesség dátuma',
      deleteAttachment_title: 'Melléklet törlése',
      deleteBoard_title: 'Tábla törlése',
      deleteCard_title: 'Kártya törlése',
      deleteComment_title: 'Megjegyzés törlése',
      deleteLabel_title: 'Címke törlése',
      deleteList_title: 'Lista törlése',
      deleteProject_title: 'Projekt törlése',
      deleteTask_title: 'Feladat törlése',
      deleteUser_title: 'Felhasználó törlése',
      description: 'Leírás',
      detectAutomatically: 'Automatikus érzékelés',
      dropFileToUpload: 'Dobja ide a fájlt a feltöltéshez',
      editor: 'Szerkesztő',
      editAttachment_title: 'Melléklet szerkesztése',
      editAvatar_title: 'Avatar szerkesztése',
      editBoard_title: 'Tábla szerkesztése',
      editDueDate_title: 'Esedékesség dátumának szerkesztése',
      editEmail_title: 'E-mail szerkesztése',
      editInformation_title: 'Információ szerkesztése',
      editLabel_title: 'Címke szerkesztése',
      editPassword_title: 'Jelszó szerkesztése',
      editPermissions_title: 'Jogosultságok szerkesztése',
      editStopwatch_title: 'Stopper szerkesztése',
      editUsername_title: 'Felhasználónév szerkesztése',
      email: 'E-mail',
      emailAlreadyInUse: 'Az e-mail cím már használatban van',
      enterCardTitle: 'Adja meg a kártya címét... [Ctrl+Enter] az automatikus megnyitáshoz.',
      enterDescription: 'Adja meg a leírást...',
      enterFilename: 'Adja meg a fájl nevét',
      enterListTitle: 'Adja meg a lista címét...',
      enterProjectTitle: 'Adja meg a projekt címét',
      enterTaskDescription: 'Adja meg a feladat leírását...',
      filterByLabels_title: 'Szűrés címkék alapján',
      filterByMembers_title: 'Szűrés tagok alapján',
      fromComputer_title: 'Számítógépről',
      fromTrello: 'Trello-ról',
      general: 'Általános',
      hours: 'Órák',
      importBoard_title: 'Tábla importálása',
      invalidCurrentPassword: 'Érvénytelen jelenlegi jelszó',
      labels: 'Címkék',
      language: 'Nyelv',
      leaveBoard_title: 'Tábla elhagyása',
      leaveProject_title: 'Projekt elhagyása',
      linkIsCopied: 'Link másolva',
      list: 'Lista',
      listActions_title: 'Lista műveletek',
      managers: 'Menedzserek',
      managerActions_title: 'Menedzseri műveletek',
      members: 'Tagok',
      memberActions_title: 'Tag műveletek',
      minutes: 'Percek',
      moveCard_title: 'Kártya áthelyezése',
      name: 'Név',
      newestFirst: 'Újabbak előre',
      newEmail: 'Új e-mail',
      newPassword: 'Új jelszó',
      newUsername: 'Új felhasználónév',
      noConnectionToServer: 'Nincs kapcsolat a szerverrel',
      noBoards: 'Nincsenek táblák',
      noLists: 'Nincsenek listák',
      noProjects: 'Nincsenek projektek',
      notifications: 'Értesítések',
      noUnreadNotifications: 'Nincsenek olvasatlan értesítések.',
      oldestFirst: 'Régebbi előre',
      openBoard_title: 'Tábla megnyitása',
      optional_inline: 'opcionális',
      organization: 'Szervezet',
      phone: 'Telefon',
      preferences: 'Beállítások',
      pressPasteShortcutToAddAttachmentFromClipboard:
        'Tipp: nyomja meg a Ctrl-V (Cmd-V a Mac-en) billentyűkombinációt a vágólapról történő melléklet hozzáadásához.',
      project: 'Projekt',
      projectNotFound_title: 'Projekt nem található',
      removeManager_title: 'Menedzser eltávolítása',
      removeMember_title: 'Tag eltávolítása',
      searchLabels: 'Címkék keresése...',
      searchMembers: 'Tagok keresése...',
      searchUsers: 'Felhasználók keresése...',
      searchCards: 'Kártyák keresése..',
      seconds: 'Másodpercek',
      selectBoard: 'Válassza ki a táblát',
      selectList: 'Válassza ki a listát',
      selectPermissions_title: 'Jogosultságok kiválasztása',
      selectProject: 'Válassza ki a projektet',
      settings: 'Beállítások',
      sortList_title: 'Rendezés listában',
      stopwatch: 'Stopper',
      subscribeToMyOwnCardsByDefault: 'Alapértelmezés szerint feliratkozás a saját kártyáimra',
      taskActions_title: 'Feladat műveletek',
      tasks: 'Feladatok',
      thereIsNoPreviewAvailableForThisAttachment: 'Nincs elérhető előnézet ehhez a melléklethez.',
      time: 'Idő',
      title: 'Cím',
      userActions_title: 'Felhasználói műveletek',
      userAddedThisCardToList:
        '<0>{{user}}</0><1> hozzáadta ezt a kártyát a következőhöz: {{list}}</1>',
      userLeftNewCommentToCard:
        '{{user}} új kommentet hagyott itt: «{{comment}}» a következő kártyán: <2>{{card}}</2>',
      userMovedCardFromListToList:
        '{{user}} áthelyezte ezt a kártyát innen: {{fromList}} ide: {{toList}}',
      userMovedThisCardFromListToList:
        '<0>{{user}}</0><1> áthelyezte ezt a kártyát innen: {{fromList}} ide: {{toList}}</1>',
      username: 'Felhasználónév',
      usernameAlreadyInUse: 'A felhasználónév már használatban van',
      users: 'Felhasználók',
      version: 'Verzió',
      viewer: 'Néző',
      writeComment: 'Írjon egy megjegyzést...',
    },

    action: {
      addAnotherCard: 'Új kártya hozzáadása',
      addAnotherList: 'Új lista hozzáadása',
      addAnotherTask: 'Új feladat hozzáadása',
      addCard: 'Kártya hozzáadása',
      addCard_title: 'Kártya hozzáadása',
      addComment: 'Megjegyzés hozzáadása',
      addList: 'Lista hozzáadása',
      addMember: 'Tag hozzáadása',
      addMoreDetailedDescription: 'További részletes leírás hozzáadása',
      addTask: 'Feladat hozzáadása',
      addToCard: 'Kártyához hozzáadása',
      addUser: 'Felhasználó hozzáadása',
      copyLink_title: 'Link másolása',
      createBoard: 'Tábla létrehozása',
      createFile: 'Fájl létrehozása',
      createLabel: 'Címke létrehozása',
      createNewLabel: 'Új címke létrehozása',
      createProject: 'Projekt létrehozása',
      delete: 'Törlés',
      deleteAttachment: 'Melléklet törlése',
      deleteAvatar: 'Avatar törlése',
      deleteBoard: 'Tábla törlése',
      deleteCard: 'Kártya törlése',
      deleteCard_title: 'Kártya törlése',
      deleteComment: 'Megjegyzés törlése',
      deleteImage: 'Kép törlése',
      deleteLabel: 'Címke törlése',
      deleteList: 'Lista törlése',
      deleteList_title: 'Lista törlése',
      deleteNotifications: 'Dismiss all',
      deleteProject: 'Projekt törlése',
      deleteProject_title: 'Projekt törlése',
      deleteTask: 'Feladat törlése',
      deleteTask_title: 'Feladat törlése',
      deleteUser: 'Felhasználó törlése',
      duplicate: 'Másolás',
      duplicateCard_title: 'Kártya másolása',
      edit: 'Szerkesztés',
      editDueDate_title: 'Esedékesség dátumának szerkesztése',
      editDescription_title: 'Leírás szerkesztése',
      editEmail_title: 'E-mail szerkesztése',
      editInformation_title: 'Információ szerkesztése',
      editPassword_title: 'Jelszó szerkesztése',
      editPermissions: 'Jogosultságok szerkesztése',
      editStopwatch_title: 'Stopper szerkesztése',
      editTitle_title: 'Cím szerkesztése',
      editUsername_title: 'Felhasználónév szerkesztése',
      hideDetails: 'Részletek elrejtése',
      import: 'Importálás',
      leaveBoard: 'Tábla elhagyása',
      leaveProject: 'Projekt elhagyása',
      logOut_title: 'Kijelentkezés',
      makeCover_title: 'Borító készítése',
      move: 'Áthelyezés',
      moveCard_title: 'Kártya áthelyezése',
      remove: 'Eltávolítás',
      removeBackground: 'Háttér eltávolítása',
      removeCover_title: 'Borító eltávolítása',
      removeFromBoard: 'Eltávolítás a tábláról',
      removeFromProject: 'Eltávolítás a projektről',
      removeManager: 'Menedzser eltávolítása',
      removeMember: 'Tag eltávolítása',
      save: 'Mentés',
      showAllAttachments: 'Összes melléklet megjelenítése ({{hidden}} rejtve)',
      showDetails: 'Részletek megjelenítése',
      showFewerAttachments: 'Kevesebb melléklet megjelenítése',
      sortList_title: 'Rendezés listában',
      start: 'Indítás',
      stop: 'Megállítás',
      subscribe: 'Feliratkozás',
      unsubscribe: 'Leiratkozás',
      uploadNewAvatar: 'Új avatar feltöltése',
      uploadNewImage: 'Új kép feltöltése',
    },
  },
};
